import styled, { css } from 'styled-components';

const LabelTitle = styled.label`
  cursor: pointer;
  font-weight: bold;
  margin-bottom: 5px;
  display: flex;
  margin-right: auto;
`;

interface IElementWrapperProps {
  isDisabled?: boolean;
  label?: string;
}

const getDisabledElementWrapper = ({ isDisabled }: IElementWrapperProps) =>
  isDisabled &&
  css`
    > * {
      opacity: 0.7;
      cursor: not-allowed;
    }
  `;

export const Wrapper = styled.div<IElementWrapperProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  flex-direction: column;
  margin-bottom: 10px;
  input,
  select {
    width: 100%;
  }
  ${getDisabledElementWrapper};
  &.error {
    margin-bottom: 5px;
    input,
    select {
      border: 2px solid #e02120;
      color: #e02120;
    }
  }
`;
const ErrorWrapper = styled.div`
  color: #ff003a;
  font-size: 12px;
  margin-top: 5px;
  display: flex;
  margin-right: auto;
  margin-left: 5px;
`;

interface IProps {
  label?: string;
  className?: string;
  isDisabled?: boolean;
  errorText?: string;
  id?: string;
}

export const FormPart: React.FC<IProps> = ({
  errorText,
  label,
  children,
  className = '',
  isDisabled,
  id
}) => (
  <Wrapper className={`${className} ${errorText ? 'error' : ''}`} isDisabled={isDisabled}>
    {!!label && <LabelTitle htmlFor={id}>{label}</LabelTitle>}
    {children}
    {!!errorText && <ErrorWrapper data-cy="component-validation-error">{errorText}</ErrorWrapper>}
  </Wrapper>
);
